export const FROM_PARAM = 'from';
export const TO_PARAM = 'to';
export const DEPARTURE_FROM_PARAM = 'departurefrom';
export const DEPARTURE_TO_PARAM = 'departureto';
export const NIGHTS_FROM_PARAM = 'nightsfrom';
export const NIGHTS_TO_PARAM = 'nightsto';
export const ADULTS_PARAM = 'adults';
export const CURRENCY_PARAM = 'currency';

export const KIDS_PARAM = 'kids';
export const KIDS_AGES_PARAM = 'kidsAges';
export const HOTELS_PARAM = 'hotels';
export const HOTEL_PARAM = 'hotel';
export const STARS_PARAM = 'stars';
export const RATING_PARAM = 'rating';
export const MEALS_PARAM = 'meals';
export const BEACH_LINE_PARAM = 'beachline';
export const BEACH_TYPE_PARAM = 'beachtype';
export const HOTEL_TYPE_PARAM = 'hoteltype';
export const CHARTER_ONLY_PARAM = 'charter';
export const DIRECT_PARAM = 'direct';
export const OPERATORS_PARAM = 'operators';
export const SERVICES_PARAM = 'services';
export const REGION_PARAM = 'region';
export const SUBREGION_PARAM = 'subregion';
export const MIN_PRICE_PARAM = 'minprice';
export const MAX_PRICE_PARAM = 'maxprice';
export const TOUR_ID = 'tourid';
export const EMAIL_PARAM = 'email';
export const CODE_PARAM = 'code';
export const PASS_PARAM = 'pass';

export const HOME_PAGE = '/';
